import { render, staticRenderFns } from "./PipeExtractionTongre.vue?vue&type=template&id=c6fa1cc4&scoped=true"
import script from "./PipeExtractionTongre.vue?vue&type=script&lang=js"
export * from "./PipeExtractionTongre.vue?vue&type=script&lang=js"
import style0 from "./PipeExtractionTongre.vue?vue&type=style&index=0&id=c6fa1cc4&prod&lang=scss"
import style1 from "./PipeExtractionTongre.vue?vue&type=style&index=1&id=c6fa1cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fa1cc4",
  null
  
)

export default component.exports